import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import Grid from '@material-ui/core/Grid';

import ListUnit from './ListUnit';
import RelayListUnit from './ListUnit.relay';

const styles = theme => ({
  inner_container: {
    position:'absolute',
    top:0,
    left:0,
    bottom:0,
    height:'100%',
    width:"100%",
    overflow:'scroll',
    background:theme.palette.white
  }
});
export const ListComponent = ({
      classes,
      icon_type,
      selected_value,
      search_value,
      suggestions,
      handle_select,
      ContainerComponent = Grid,
      InnerContainer = Grid,
      fetch_type,
      ...other
    }) => {

      const ListItemComponent = React.useMemo(() => {
        return fetch_type === "no-fetch"
          ? ListUnit
          : RelayListUnit;
      },[fetch_type]);

      if (!suggestions || !suggestions.length) { return null; }

      return (
        <ContainerComponent
          className = {other.className || ""}
          style = {{
            position:'relative',
            minHeight: Math.min(((suggestions && suggestions.length) || 0) * 56, 300),
          }}
        >
        <InnerContainer className = {classes.inner_container}>
        {
          suggestions.map((item, index) => (
            <ListItemComponent
                key = {item.id || `list-itme-${index}`}
                item = {item}
                selected_value = {selected_value}
                handle_select = {handle_select}
                icon_type = {icon_type}
                search_value = {search_value}
            />
          ))

        }
        </InnerContainer>
      </ContainerComponent>
  )
};

ListComponent.propTypes = {
  icon_type: PropTypes.string,
  selected_value: PropTypes.string,
  search_value: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })),
  handle_select: PropTypes.func,
  ContainerComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  InnerContainer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  fetch_type: PropTypes.oneOf(["no-fetch","fetch","re-fetch"])
}

ListComponent.defaultProps = {
  ContainerComponent: Grid,
  InnerContainer: Grid
}

export default React.memo(withStyles(styles)(ListComponent));
